import { render } from "./TheLanguage.vue?vue&type=template&id=137a08b1"
import script from "./TheLanguage.vue?vue&type=script&lang=js"
export * from "./TheLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__